var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Search',{attrs:{"url":_vm.url,"title":_vm.$lang.searchAlgorithmExercise,"remove_item":_vm.remove_item,"addModalSize":"lg","removeModalSize":"xl","toggleable":true,"dynamicButtons":_vm.buttons},scopedSlots:_vm._u([{key:"addModal",fn:function(search){return [_c('AddExerciseAlgorithm',{attrs:{"isModal":""},on:{"modal-end-up":search.close}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }